import { CuraHeading } from '@rededor/cura-react'
import { JSX } from 'react'
import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

interface LoadingStore {
  isLoading: boolean
  loadingContent: JSX.Element
  setLoadingState(state: boolean): void
  setLoadingContent(content: JSX.Element): void
}

export const useLoadingStore = create<LoadingStore>()(
  devtools(
    (set) => ({
      isLoading: false,
      loadingContent: (
        <CuraHeading size="small" color="primary" weight="bold">
          Carregando Agendamento de Consultas
        </CuraHeading>
      ),
      setLoadingState(state = false) {
        set({ isLoading: state }, false, 'setLoadingState')
      },
      setLoadingContent(content = <></>) {
        set({ loadingContent: content }, false, 'setLoadingContent')
      }
    }),
    { name: 'useLoadingStore' }
  )
)
